let siteName = 'velkinewagentlist';
let WLID = '2663463';
let hostname = window.origin;
let origin = 'playagentlist.com';
let AgentListLink = 'localhost';

if (hostname.indexOf('panel.playagentlist.com') > -1) {
  siteName = 'play25';
  WLID = '2663463'
  origin = 'playagentlist.com'
  AgentListLink = 'https://playagentlist.com/'
}
else if (hostname.indexOf('panel.vrnlofficial.com') > -1) {
  siteName = 'vrnlofficial';
  WLID = '1601277'
  origin = 'vrnlofficial.com'
  AgentListLink = 'https://vrnlofficial.com/'
}
else if (hostname.indexOf('panel.bety247.info') > -1) {
  siteName = 'bety247';
  WLID = '1866687'
  origin = 'bety247.info'
  AgentListLink = 'https://bety247.info/'
}
else if (hostname.indexOf('panel.risxbet.com') > -1) {
  siteName = 'risxbet';
  WLID = '4112338'
  origin = 'risxbet.com'
  AgentListLink = 'https://risxbet.com/'
}
else if (hostname.indexOf('panel.vellkielist.com') > -1) {
  siteName = 'vellkielist';
  origin = 'vellkielist.com'
  AgentListLink = 'https://vellkielist.com/'
}
else if (hostname.indexOf('panel.foxplaybdagentlist.com') > -1) {
  siteName = 'foxplaybd';
  origin = 'foxplaybdagentlist.com'
  AgentListLink = 'https://foxplaybd.com/'
}
else if (hostname.indexOf('panel.lcagentlist.com') > -1) {
  siteName = 'lcagentlist';
  origin = 'lcagentlist.com'
  AgentListLink = 'https://lcagentlist.com/'
}

else if (hostname.indexOf('panel.bazzi365agentlist.com') > -1) {
  siteName = 'bazzi365agentlist';
  origin = 'bazzi365agentlist.com'
  AgentListLink = 'https://bazzi365agentlist.com/'
}

else if (hostname.indexOf('panel.9wicktsvipagentlist.pro') > -1) {
  siteName = 'wicktsvipagentlist';
  origin = '9wicktsvipagentlist.pro'
  WLID = '5633374'
  AgentListLink = 'https://9wicktsvipagentlist.pro/'
}
else if (hostname.indexOf('panel.velkinew.live') > -1) {
  siteName = 'velkinewagentlist';
  origin = 'velkinew.live'
  WLID = '6271983'
}

export const environment = {
  production: true,
  siteName: siteName,
  hostname:hostname,
  origin:origin,
  WLID:WLID,
  AgentListLink:AgentListLink,
  apiBaseUrl: 'https://api2.streamingtv.fun:3479'
};
